import React from "react";
import { control } from "react-validation";

import { ValidationContext } from "../validation/ValidationContext";

import Errors from "./Error";

const MultiInput = ({
  hasErrors,
  error,
  isChanged,
  isUsed,
  className,
  errorClassName,
  category,
  field,
  onChange,
  ...props
}) => (
  <ValidationContext.Consumer>
    {({ backErrors, hideError }) => {
      let hasError = (isUsed && error) || (backErrors && backErrors[field]);

      return (
        <div className={`${hasError ? errorClassName || "" : ""}`}>
          <textarea
            {...props}
            onChange={(e) => {
              onChange(e);
              hideError(field);
            }}
            className={hasError ? "is-invalid-input" : ""}
          />
          {hasError ? (
            <Errors
              category={category}
              field={field}
              backErrors={backErrors}
              className="error-message is-visible"
            >
              {error}
            </Errors>
          ) : (
            ""
          )}
        </div>
      );
    }}
  </ValidationContext.Consumer>
);

export default control(MultiInput);
